/*
 * YOUR DESIGN ON OTHER THINGS (owner 2026-10-01; SCOPE-CROSS-SELL.md).
 *
 * <mg-design-row data-place="cart|drawer" data-api="/apps/design" data-meta="{...}">
 *
 * The slim row under the cart items that shows the customer's own art on a few
 * other products. The server decides everything (what to show, in what order,
 * at what price, in whose words) and sends the finished row as HTML; this
 * script only asks, drops it in, and keeps four promises:
 *
 *   - NEVER before something with a design is in the cart: the Liquid only
 *     prints the element then.
 *   - NEVER in the way: it asks only when the row is about to scroll into view
 *     (or, in the drawer, once the drawer is open), draws nothing at all when
 *     the server says no, and a failure of any kind leaves the page exactly as
 *     it was.
 *   - NEVER a pop-up. "No thanks" hides the row for THIS VISIT only
 *     (sessionStorage; the next visit shows it again).
 *   - A tile whose product is not for sale (its page answers 404, or it is
 *     sold out) or whose picture fails to load is taken away, and the row
 *     with it when none is left.
 *
 * It counts two things, through a door that never fails the page: the row was
 * seen, and a tile was tapped. The shop's own device (mgStaff) is counted apart.
 */
(function () {
  'use strict';
  if (window.customElements.get('mg-design-row')) return;

  var HIDE_KEY = 'mgXsHidden';
  var answers = {};      // this page's answers, by cart signature, so a redraw is instant
  var seenSent = {};     // one "seen" per place per page

  function hiddenThisVisit() {
    try { return window.sessionStorage.getItem(HIDE_KEY) === '1'; } catch (e) { return false; }
  }
  function hideThisVisit() {
    try { window.sessionStorage.setItem(HIDE_KEY, '1'); } catch (e) { /* nothing to keep */ }
  }
  function isStaff() {
    try { return window.localStorage.getItem('mgStaff') === '1'; } catch (e) { return false; }
  }

  function MgDesignRow() {
    return Reflect.construct(HTMLElement, [], MgDesignRow);
  }
  MgDesignRow.prototype = Object.create(HTMLElement.prototype);
  MgDesignRow.prototype.constructor = MgDesignRow;
  Object.setPrototypeOf(MgDesignRow, HTMLElement);

  MgDesignRow.prototype.api = function () {
    return this.getAttribute('data-api') || '/apps/design';
  };
  MgDesignRow.prototype.place = function () {
    return this.getAttribute('data-place') || 'cart';
  };

  MgDesignRow.prototype.connectedCallback = function () {
    if (this._started) return;
    this._started = true;
    if (hiddenThisVisit()) return;
    var self = this;
    this.addEventListener('click', function (e) { self.onClick(e); });
    // a picture that will not load takes its tile with it
    this.addEventListener('error', function (e) {
      var img = e.target;
      if (img && img.tagName === 'IMG') self.dropTile(img.closest('li'));
    }, true);
    this.whenReady(function () { self.load(); });
  };

  // Ask only when the row is about to be seen; in the drawer, only once it is open.
  MgDesignRow.prototype.whenReady = function (fn) {
    var self = this;
    var drawer = this.closest ? this.closest('cart-drawer') : null;
    function visible() {
      if (!('IntersectionObserver' in window)) { fn(); return; }
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { io.disconnect(); fn(); return; }
        }
      }, { rootMargin: '400px' });
      io.observe(self);
    }
    // In the drawer the row loads the moment the drawer is open, never on an
    // IntersectionObserver: it starts zero-height at the foot of the drawer's
    // own scrolling list, so it never counted as "in view" and the drawer row
    // stayed empty (live check 2026-10-02).
    if (drawer) {
      if (drawer.classList.contains('active')) { fn(); return; }
      var mo = new MutationObserver(function () {
        if (drawer.classList.contains('active')) { mo.disconnect(); fn(); }
      });
      mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      return;
    }
    visible();
  };

  MgDesignRow.prototype.load = function () {
    var self = this;
    var api = this.api();
    var place = this.place();
    var meta = {};
    try { meta = JSON.parse(this.getAttribute('data-meta') || '{}') || {}; } catch (e) { meta = {}; }
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return null;
        var sig = place + ':';
        var items = [];
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          var m = meta[it.handle] || {};
          sig += it.key + ',';
          items.push({
            handle: it.handle,
            design_key: p._design_key || '',
            // a tiered line carries its design inline; a keyed one never sends it twice
            design: p._design_key ? '' : (p._design || ''),
            campaign: !!p._campaign_id,
            tags: m.t || [],
            collections: m.c || []
          });
        });
        if (answers[sig]) return answers[sig];
        return fetch(api + '/api/cross-sell/suggest', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ place: place, items: items })
        }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (res) { if (res) answers[sig] = res; return res; });
      })
      .then(function (res) {
        // Said "no" (or could not say): nothing is drawn and nothing is in the way.
        if (!res || !res.show || !res.html || hiddenThisVisit()) return;
        self.draw(res);
      })
      .catch(function () { /* the cart page must never feel this */ });
  };

  MgDesignRow.prototype.draw = function (res) {
    var self = this;
    this.style.display = 'none';          // until at least one tile checks out
    this.innerHTML = res.html;
    var tiles = Array.prototype.slice.call(this.querySelectorAll('[data-mg-xs-tile]'));
    Promise.all(tiles.map(function (a) {
      var handle = a.getAttribute('data-mg-xs-handle');
      return fetch('/products/' + encodeURIComponent(handle) + '.js',
                   { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) return false;                     // not for sale: draft or gone
          return r.json().then(function (p) { return !(p && p.available === false); });
        })
        .catch(function () { return true; })           // no signal is not "out"
        .then(function (ok) { if (!ok) self.dropTile(a.closest('li')); });
    })).then(function () {
      if (!self.querySelector('[data-mg-xs-tile]')) { self.innerHTML = ''; return; }
      self.style.display = '';
      self.watchSeen();
    });
  };

  MgDesignRow.prototype.dropTile = function (li) {
    if (!li || !li.parentNode) return;
    li.parentNode.removeChild(li);
    if (!this.querySelector('[data-mg-xs-tile]')) { this.innerHTML = ''; this.style.display = 'none'; }
  };

  MgDesignRow.prototype.watchSeen = function () {
    var self = this;
    var place = this.place();
    if (seenSent[place]) return;
    var row = this.querySelector('.mg-xs');
    if (!row) return;
    function send() {
      if (seenSent[place]) return;
      seenSent[place] = true;
      self.count('seen', '');
    }
    if (!('IntersectionObserver' in window)) { send(); return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { io.disconnect(); send(); return; }
      }
    }, { threshold: 0.4 });
    io.observe(row);
  };

  MgDesignRow.prototype.count = function (event, product) {
    try {
      fetch(this.api() + '/api/cross-sell/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ event: event, place: this.place(), product: product, staff: isStaff() })
      }).catch(function () { /* nobody waits on a count */ });
    } catch (e) { /* nor does it matter */ }
  };

  MgDesignRow.prototype.onClick = function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dismiss = t.closest('[data-mg-xs-dismiss]');
    if (dismiss) {
      e.preventDefault();
      hideThisVisit();
      var rows = document.querySelectorAll('mg-design-row');
      for (var i = 0; i < rows.length; i++) { rows[i].innerHTML = ''; rows[i].style.display = 'none'; }
      return;
    }
    var tile = t.closest('[data-mg-xs-tile]');
    if (tile) this.count('click', tile.getAttribute('data-mg-xs-tile'));
    // the link itself carries the customer on to that product's designer
  };

  window.customElements.define('mg-design-row', MgDesignRow);
})();
